import type { TemplateField } from '../types/entities';

export interface EntityProfileTrait { label: string; value: string }

export function buildEntityProfileTraits(
  fields: TemplateField[],
  fieldValues: Record<string, unknown>,
  formatValue: (value: unknown) => string,
  configuredKeys?: string[] | null
): EntityProfileTrait[] {
  const visibleFields = Array.isArray(configuredKeys)
    ? configuredKeys.flatMap((key) => fields.find((field) => field.key === key) ?? [])
    : fields;
  const traits = visibleFields
    .map((field) => ({ label: field.label, value: formatValue(fieldValues[field.key]) }))
    .filter((field) => field.value);
  return Array.isArray(configuredKeys) ? traits : traits.slice(0, 4);
}
